import React from 'react'
import SectionCollapse from '../../../../../section/SectionCollapse'
import PaperBase from '../../../../../Paper/PaperBase'
import { Typography } from '@mui/material'

const RenderCurriculum = ({ id, element = {}, lcs }) => {
  const newlcs = (kid) => lcs.map((lc) => {
    const lcData = lc.curriculumElements[id] || {};
    return {
      ...lc,
      curriculumElements: {
        [kid]: lcData?.children ? lcData.children[kid] : {}
      }
    }
  })

  return (
    <>
      {Object.keys(element?.children || {}).map((lcKey) => {
        return (
          <RenderCurriculum
            key={`structure-${id}-element-${lcKey}`}
            id={lcKey}
            element={element?.children[lcKey]}
            lcs={newlcs(lcKey)}
          />
        )
      })}
      <div className="flex flex-nowrap w-full gap-1" key={id}>
        <PaperBase
          backgroundColor={element?.primaryColor}
          color={element?.secondaryColor}
          className='font-bold min-w-120px max-w-120px sticky left-0 z-10'
          children={element?.name}
        />
        { lcs.map((lc) => {
          const lcData = lc.curriculumElements[id] || {};
          return (
            <PaperBase
              key={`structure-${id}-lc-${lc._id}`}
              backgroundColor={element?.primaryColor}
              color={element?.secondaryColor}
              className={[
                'min-w-200px w-full text-ellipsis',
                lcData.value ? '' : 'bg-lines'
              ].join(' ')}
              children={<Typography className='text-ellipsis'>{lcData?.value?.name || lcData?.value?._id}</Typography>}
            />
          )
        })}
      </div>
    </>
  )
}

const FormGranularStepsPreview = ({ lcs = [] }) => {
  const newLCs = [...lcs]
  const currentCurriculum = {
    levels: [],
    lcElements: [],
    elements: {}
  }
  let levels = []
  let lcElements = []
  let elements = {}
  newLCs.forEach((lc) => {
    const lvls = lc.granularSteps?.filter((step) => step.definition)
    lcElements = [...lcElements, ...lc.lcElements]
    levels = [...levels, ...lvls]
    if (lc.curriculumElements) {
      const mapData = (key, data, currentCurriculum = {}) => {
        if (currentCurriculum[key]) {
          if (data?.children) {
            Object.keys(data.children).forEach((k) => {
              currentCurriculum[key].children = mapData(k, data.children[k], currentCurriculum[key].children)
            })
          }
        } else {
          currentCurriculum[key] = {...data}
          delete currentCurriculum[key].value
        }

        return currentCurriculum
      }
      Object.keys(lc.curriculumElements).forEach((key) => {
        mapData(key, lc.curriculumElements[key], elements)
      })
    }
  })

  currentCurriculum.elements = elements
  let levelsId = levels.map((item) => item.levelId)
  levelsId = [...new Set(levelsId)]

  levels.forEach((item) => {
    if (levelsId.includes(item.levelId)) {
      const find = currentCurriculum.levels.find((level) => level._id === item.levelId)
      if (!find) {
        currentCurriculum.levels.push({
          _id: item.levelId,
          name: item.name,
          position: item.position,
          primaryColor: item?.primaryColor,
          secondaryColor: item?.secondaryColor
        })
      }
    }
  })

  lcElements.forEach((item) => {
    const find = currentCurriculum.lcElements.find((element) => element._id === item.elementId)
    if (!find) {
      currentCurriculum.lcElements.push({
        _id: item.elementId,
        ...item
      })
    }
  })

  return (
    <div className={
      ['py-1 flex flex-col gap-1', lcs.length > 3 ? 'w-fit' : 'w-auto']
      .join(' ')
    }>
      {currentCurriculum?.levels?.filter((item) => levelsId.includes(item._id))
        .sort((a, b) => b.position - a.position)
        .map((item) => (
        <div className="flex flex-nowrap w-full gap-1" key={item._id}>
          <PaperBase 
            backgroundColor={item?.secondaryColor}
            color={item?.primaryColor}
            className='font-bold min-w-120px max-w-120px sticky left-0 z-10'
            children={item.name}
          />
          { lcs?.map((lc) => {
            const find = lc.granularSteps?.find((step) => step.levelId === item._id)
            return (
              <PaperBase 
                key={`levels-${item._id}-lc-${lc._id}`}
                backgroundColor={find ? item?.primaryColor : null}
                color={find ? item?.secondaryColor : null}
                className={[
                  'min-w-200px w-full text-ellipsis',
                  find.definition ? '' : 'bg-lines'
                ].join(' ')}
                children={<Typography className='text-ellipsis'>{find?.definition}</Typography>}
              />
            )})
          }
          
        </div>
      ))}
      {currentCurriculum?.lcElements?.sort((a, b) => b.position - a.position)?.map((item) => (
        <div className="flex flex-nowrap w-full gap-1" key={item._id}>
          <PaperBase 
            backgroundColor={item?.secondaryColor}
            color={item?.primaryColor}
            className='font-bold min-w-120px max-w-120px sticky left-0 z-10'
            children={item.name}
          />
          { lcs?.map((lc) => {
            const find = lc.lcElements.find((step) => step.elementId === item._id)
            return (
              <PaperBase
                key={`lc-elements-${item._id}-lc-${lc._id}`}
                backgroundColor={find ? item?.secondaryColor : null}
                color={find ? item?.primaryColor : null}
                className={[
                  'min-w-200px w-full text-ellipsis',
                  find ? '' : 'bg-lines'
                ].join(' ')}
                children={<Typography className='text-ellipsis'>{find?.definition}</Typography>}
              />
            )}
          )}
        </div>
      ))}
      { Object.keys(currentCurriculum.elements).map((key) => (
        <RenderCurriculum
          id={key}
          key={key}
          element={currentCurriculum.elements[key]}
          lcs={lcs}
        />
      ))}
    </div>
  )
}

const GranularSteps = ({ lcs = [] }) => {
  return (
    <SectionCollapse title={`Granular steps (#${lcs?.length || 0} Learning continuum)`}>
      <div className='h-screen-half overflow-auto'>
        <FormGranularStepsPreview lcs={[...lcs]} />
      </div>
    </SectionCollapse>
  )
}

export default GranularSteps